<template>
  <div>
    <el-tabs v-model="activePane" @tab-click="onTabChange">
      <el-tab-pane label="Published" name="A"></el-tab-pane>
      <el-tab-pane label="Drafts" name="P"></el-tab-pane>
    </el-tabs>
    <div class="card shadow">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col-6">
            Articles
          </div>
          <div class="col-6">
            <article-create v-if="$store.getters.isAdmin || $store.getters.isMod" />
          </div>
        </div>
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Title</th>
              <th>User</th>
              <th v-if="$store.getters.isAdmin || $store.getters.isMod">Operations</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="article in articles" :key="article.id">
              <td>
                <router-link :to="{ name: 'articles-id', params: { id: article.id } }">
                  {{ article.title }}
                </router-link>
              </td>
              <td>
                <router-link :to="{ name: 'users-id', params: { id: article.user.id }}">
                  {{ article.user.name }}
                </router-link>
                <div class="text-muted">@{{ article.user.username }}</div>
              </td>
              <td>
                <article-publish v-if="$store.getters.isAdmin && article.status === 'P'" :articleId="article.id" @update="getArticles" />
                <article-view v-else :article="article" />
                <article-delete :article="article" @delete="getArticles" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ArticleCreate from '@/components/Article/ArticleCreate'
import ArticleView from '@/components/Article/ArticleView'
import ArticlePublish from '@/components/Article/ArticlePublish'
import ArticleDelete from '@/components/Article/ArticleDelete'

export default {
  data() {
    return {
      loading: true,
      activePane: 'A',
      articles: [],
    }
  },

  components: {
    ArticleCreate,
    ArticleView,
    ArticlePublish,
    ArticleDelete,
  },

  mounted() {
    this.getArticles()
  },

  methods: {
    onTabChange(tab, event) {
      this.activePane = tab.name
      this.getArticles()
    },

    async getArticles(status) {
      try {
        var { data } = await this.$http.get(`/articles`, {
          params: {
            status: this.activePane,
            limit: 512,
          }
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.articles = data.map(item => {
        item.title = item.title || '<Empty>'
        return item
      })
    },
  },
}
</script>
